<template>
  <div class="bg-semantic-surface-default py-10 md:py-20 px-4">
    <!-- eslint-disable vue/no-v-html -->
    <div class="max-w-wrapper-md w-full mx-auto">
      <p
        v-if="!_isEmpty(title) && !_isEmpty(activeTab?.label)"
        class="text-center text-2xl md:text-4xl mb-6 md:mb-4 font-semibold text-semantic-surface-on-surface"
        v-html="title?.[activeTab?.label] || title"
      />

      <p
        v-if="!_isEmpty(subHeader) && !_isEmpty(activeTab?.label)"
        class="md:text-lg text-center mb-6 md:mb-10 text-semantic-surface-on-surface"
        v-html="subHeader?.[activeTab?.label] || subHeader"
      />

      <div
        class="p-4 bg-semantic-surface-default flex flex-col md:flex-row md:items-center gap-3 justify-center border border-b-0 border-semantic-outline-default rounded-tl-2xl rounded-tr-2xl"
      >
        <div
          v-if="!_isEmpty(tableTitle)"
          class="text-xl/[120%] md:text-2xl/[120%] font-semibold text-semantic-secondary-variant-light bg-red-"
        >
          {{ tableTitle }}
        </div>

        <V2MoleculesTabs
          v-model="tabSelected"
          position="right"
          :tabs="tabs" />
      </div>

      <div
        class="border border-semantic-outline-default rounded-r-2xl rounded-t-none rounded-bl-2xl overflow-hidden border-t-0 text-sm/[150%] md:text-base/[150%]"
      >
        <div
          v-for="(item, itemKey) in list[activeTab.label]"
          :key="itemKey"
          class="flex not-last:border-b first:border-t border-semantic-outline-white bg-semantic-surface-container-high"
        >
          <div
            class="flex items-center border-r border-semantic-outline-white py-3 px-4 exact-w-[192px] md:exact-w-[200px] font-bold"
          >
            {{ itemKey }}
          </div>

          <div
            class="flex flex-1 md:items-center bg-semantic-surface-container-lowest py-3 px-4"
            v-html="item"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import _isEmpty from 'underscore/cjs/isEmpty.js'

defineOptions({
  name: 'V2OrganismHomeTableTabs'
})

const props = defineProps({
  title: {
    type: [String, Object],
    default: ''
  },

  tableTitle: {
    type: [String, Object],
    default: ''
  },

  subHeader: {
    type: [String, Object],
    default: ''
  },

  tabs: {
    type: Array,
    default: () => ['Tab 1', 'Tab 2']
  },

  list: {
    type: Object,
    default: () => ({})
  }
})

const tabSelected = ref(props.tabs[0].key)

const activeTab = computed(() =>
  props.tabs.find(item => item.key === tabSelected.value)
)
</script>
